import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { id: "playback-slider-container" }
const _hoisted_2 = { id: "tick-container" }
const _hoisted_3 = { class: "tick-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_slider = _resolveComponent("v-slider")!

  return (_openBlock(), _createElementBlock("div", {
    id: "enclosing-playback-container",
    style: _normalizeStyle(_ctx.cssVars)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.index, (val) => {
          return (_openBlock(), _createElementBlock("div", _mergeProps({ key: val }, { ref_for: true }, _ctx.options(val), { class: "tick" }), [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.valueToMark(val)), 1)
          ], 16))
        }), 128))
      ]),
      _createVNode(_component_v_slider, {
        "hide-details": "",
        modelValue: _ctx.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
        max: _ctx.max ?? _ctx.index[_ctx.index.length - 1],
        min: _ctx.min ?? _ctx.index[0],
        "thumb-size": 16,
        color: "white",
        "track-color": "white",
        "track-fill-color": "white",
        "thumb-color": "blue",
        "track-size": "8",
        step: _ctx.step,
        "show-ticks": _ctx.useBuiltInTicks ? 'always' : false,
        ticks: _ctx.useBuiltInTicks ? _ctx.marks : undefined
      }, null, 8, ["modelValue", "max", "min", "step", "show-ticks", "ticks"])
    ])
  ], 4))
}